import axios from '../../http_v2'
export default {
  list: (params) => {
    return axios.post('formbuilder/filemanager/page', params)
  },
  add: (params) => {
    return axios.post('formbuilder/filemanager/save', params)
  },
  del: (params) => {
    return axios.post('formbuilder/filemanager/delete', params)
  },
  get: (params) => {
    return axios.post('formbuilder/filemanager/get', params)
  },
  updateCount: (params) => {
    return axios.post('formbuilder/filemanager/savecount', params)
  },
  updateRange: (params) => {
    return axios.get('formbuilder/filemanager/update/range', params)
  }
}
